export default class StringUtils {
  /**
   * エラーメッセージのテンプレート内のプレースホルダーを置き換え、フォーマットされたログメッセージを構築します。
   *
   * @param msgParamList エラーメッセージ内のプレースホルダーを置き換えるための値のリスト。
   *                        順番に errCd、scanCode、requestParams を含む必要があります。
   * @param errMsg プレースホルダーを含むエラーメッセージのテンプレート（例：{0}、{1} など）。
   * @returns 対応する値でプレースホルダーが置き換えられたフォーマットされたログメッセージ。
   */
  static buildMsg(msgParamList: string[], errMsg: string): string {
    // プレースホルダー（{0}、{1} など）をマッチさせる正規表現
    const placeholderRegex = /\{(\d+)\}/g;

    // errMsg 内のプレースホルダーを logMsgParamList の値で置き換え
    return errMsg.replace(placeholderRegex, (_, index) => {
      // プレースホルダーからインデックスを抽出
      const listIndex = parseInt(index, 10);

      // インデックスが logMsgParamList の範囲内かどうかを確認し、適切な値かプレースホルダーを返す
      return listIndex < msgParamList.length ? msgParamList[listIndex] : '';
    });
  }
}
